import React from "react";
import "./Forms.scss";

const Forms = () => {
  const SecurityDeclaration30días = () => {
    const url = process.env.PUBLIC_URL + "Forms/SecurityDeclaration30días.docx";

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "SecurityDeclaration30días.docx";

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const SecurityDeclaration180días = () => {
    const url =
      process.env.PUBLIC_URL + "Forms/SecurityDeclaration180días.docx";

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "SecurityDeclaration180días.docx";

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const SecurityDeclarationTSA = () => {
    const url = process.env.PUBLIC_URL + "Forms/SecurityDeclarationTSA.docx";

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "SecurityDeclarationTSA.docx";

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
  };

  return (
    <section id="Forms" className="Forms">
      <div className="Forms-container">
        <div className="Forms-container_title">Formularios</div>
        <div className="Forms-container_subTitle">
          Descargar los formularios en formato .docx
        </div>
        <div className="Forms-container_buttons">
          <div className="Forms-container_buttons--button">
            <div
              className="Forms-container_buttons--button__txt"
              onClick={SecurityDeclaration30días}
            >
              - Security Declaration 30 días
            </div>
          </div>
          <div className="Forms-container_buttons--button">
            <div
              className="Forms-container_buttons--button__txt"
              onClick={SecurityDeclaration180días}
            >
              - Security Declaration 180 días
            </div>
          </div>
          <div className="Forms-container_buttons--button">
            <div
              className="Forms-container_buttons--button__txt"
              onClick={SecurityDeclarationTSA}
            >
              - Security Declaration TCA
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Forms;
